import Swiper, { Navigation } from 'swiper';

const gallerySliders = document.querySelectorAll('.gallerySlider');

if (gallerySliders) {
    gallerySliders.forEach((gallerySlider, i) => {
        if (i >= 1) {
            gallerySliders[i].parentElement.classList.add('gallerySlider-fixPadding');
        }

        const galleryId = gallerySlider.getAttribute('data-gallery-id');

        const swiper = new Swiper(
            `.gallerySlider[data-gallery-id="${galleryId}"] .gallerySlider__swiper .swiper`,
            {
                modules: [Navigation],
                loop: true,
                spaceBetween: 18,
                slidesPerView: 1.25,
                breakpoints: {
                    768: {
                        slidesPerView: 2.6,
                    },
                },
                navigation: {
                    nextEl: `.gallerySlider[data-gallery-id="${galleryId}"] .gallerySlider__next`,
                    prevEl: `.gallerySlider[data-gallery-id="${galleryId}"] .gallerySlider__prev`,
                },
            },
        );
    });
}
